<template>
  <div class="steps-block py-5">
	<div class="row ps-3">
	  <div class="steps" :class="getClasses(1)">
		<strong>1</strong>
	  </div>
	  <div class="line-dash"></div>
	  <div class="steps" :class="getClasses(2)">
		<strong>2</strong>
	  </div>
	  <div class="line-dash"></div>
	  <div class="steps" :class="getClasses(3)">
		<strong>3</strong>
	  </div>
	  <div class="line-dash"></div>
	  <div class="steps" :class="getClasses(4)">
		<strong>4</strong>
	  </div>
	</div>
  </div>
</template>

<script setup>
const props = defineProps({
  activeStep: Number
})

function getClasses(step) {
	if (step === props.activeStep) {
		return "step-active";
	} else if (props.activeStep > step) {
		return "step-completed";
	}
}
</script>
